import { createFileRoute } from "@tanstack/react-router";
import { MultilingualServiceLanding } from "@/components/MultilingualServiceLanding";
import { JA_TRANSLATE } from "@/data/ja-service-content";
import { SEO_SITE, multiHreflangLinks, ctaDesc, ctaTitle } from "@/lib/seo";

const PATH = "/ja/translate";
const C = JA_TRANSLATE;

export const Route = createFileRoute("/ja/translate")({
  head: () => ({
    meta: [
      { title: ctaTitle("バンコク 日本語認証翻訳 | NYC Legal(MOJ 登録翻訳者)", "/ja/translate", "th")},
      { name: "description", content: ctaDesc("日本語 ⇄ タイ語 / 英語の認証翻訳。タイ司法省登録翻訳者 + 翻訳会社印付。婚姻・戸籍・無犯罪・卒業証明など 1〜3 営業日で発行。. Ask us anything — real experts reply within minutes.", "/ja/translate", "th")},
      { property: "og:title", content: ctaTitle("バンコク 日本語認証翻訳 | NYC Legal", "/ja/translate", "th")},
      { property: "og:description", content: ctaDesc("MOJ 登録翻訳者によるプロ翻訳。LINE で 30 分以内に見積。", "/ja/translate", "th")},
      { property: "og:url", content: `${SEO_SITE}${PATH}` },
      { property: "og:locale", content: "ja_JP" },
    ],
    links: [
      { rel: "canonical", href: `${SEO_SITE}${PATH}` },
      ...multiHreflangLinks(
        [
          { hreflang: "th-TH", path: "/translate" },
          { hreflang: "en", path: "/en/translate" },
          { hreflang: "zh", path: "/zh/translate" },
          { hreflang: "ja", path: "/ja/translate" },
          { hreflang: "x-default", path: "/translate" },
        ],
        "/translate",
      ),
    ],
    scripts: [
      {
        type: "application/ld+json",
        children: JSON.stringify({
          "@context": "https://schema.org",
          "@type": "ProfessionalService",
          name: "NYC Legal — 日本語認証翻訳",
          url: `${SEO_SITE}${PATH}`,
          areaServed: ["TH", "JP"],
          inLanguage: "ja",
          priceRange: "฿500–฿2,000",
          serviceType: "Certified Translation · Japanese / Thai / English",
          provider: { "@type": "ProfessionalService", name: "NYC Language Institute", url: SEO_SITE },
        }),
      },
      {
        type: "application/ld+json",
        children: JSON.stringify({
          "@context": "https://schema.org",
          "@type": "FAQPage",
          inLanguage: "ja",
          mainEntity: C.faqs.map((f) => ({
            "@type": "Question",
            name: f.q,
            acceptedAnswer: { "@type": "Answer", text: f.a },
          })),
        }),
      },
      {
        type: "application/ld+json",
        children: JSON.stringify({
          "@context": "https://schema.org",
          "@type": "BreadcrumbList",
          itemListElement: [
            { "@type": "ListItem", position: 1, name: "ホーム", item: `${SEO_SITE}/ja` },
            { "@type": "ListItem", position: 2, name: "翻訳", item: `${SEO_SITE}${PATH}` },
          ],
        }),
      },
    ],
  }),
  component: () => <MultilingualServiceLanding c={C} />,
});
